import React, { Component } from 'react'
import { Form, Input, Table, Icon } from 'antd'

import { editDocument } from "../redux/actions/Firebase"
import { getDocumentInfo } from "../redux/actions/Stations"

import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

import { styleShowStation } from '../styles/styles'
import { styleEditStation } from '../styles/styles'

import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import logo from "../assets/stationIcon2.png";

class ViewStation extends Component {

    constructor(props) {
        super(props)
        this.state = {
            position: [25.666202, -100.314178],
            number_slots: 0,
            date: "2017/06/18",
            columns: [
                {
                    title: 'Id',
                    dataIndex: 'number',
                    key: 'number',
                    align: 'center'
                },
                {
                    title: 'Disponible',
                    dataIndex: 'available',
                    key: 'available',
                    align: 'center',
                    render: (value) => {
                        if (value) {
                            return (
                                <Icon type="check-circle" theme="filled" style={{ color: "#3dd84c" }} />
                            )
                        } else {
                            return (
                                <div>
                                    <Icon type="close-circle" theme="filled" style={{ color: "#fb1d1d" }} />
                                </div>
                            )
                        }
                    }
                },
                {
                    title: 'Cargando',
                    dataIndex: 'charging',
                    key: 'charging',
                    align: 'center',
                    render: (value) => {
                        if (value) {
                            return (
                                <Icon type="check-circle" theme="filled" style={{ color: "#3dd84c" }} />
                            )
                        } else {
                            return (
                                <div>
                                    <Icon type="close-circle" theme="filled" style={{ color: "#fb1d1d" }} />
                                </div>
                            )
                        }
                    }
                },
                {
                    title: 'Empresa',
                    dataIndex: 'vehicle',
                    key: 'vehicle',
                    align: 'center'
                },
            ]
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        var pos = this.props.onEditionDocument
        if (pos) {
            if (this.props.onEditionDocument.position !== prevProps.onEditionDocument.position) {
                this.setState({ position: [pos[0], pos[1]] })
                this.forceUpdate()
            }
        }
    }

    render() {
	var slots = Object.values(this.props.onEditionDocument.slots)
	slots = slots.map((value, key) => ({...value, number: key}))
        return (
            <div style={styleShowStation.mainDiv}>
                <h1>Estación</h1>
                <div style={styleShowStation.infoDiv}>
                </div>
                <Form layout="inline" onSubmit={this.handleSubmit}>
                    <Form.Item>
                        <Input
                            value={this.props.onEditionDocument.position}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Input
                            value={this.props.onEditionDocument.slots.length}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Input
                            value={this.props.onEditionDocument.date}
                        />
                    </Form.Item>
                </Form>
                <h2 style={{ paddingTop: 20, marginBottom: 0 }}>Slots</h2>
                <Table dataSource={slots} columns={this.state.columns} style={styleEditStation.slotsTable} rowKey="number" />
                <div style={styleEditStation.mapStyle}>

                    <Map
                        google={this.props.google}
                        zoom={13}
                        style={{ width: '80%', height: 760 }}
                        initialCenter={{
                            lat: this.state.position[0], 
                            lng: this.state.position[1]
                        }}
                    >
                        <Marker 
                            icon={logo}
                            position={{
                                lat: this.props.onEditionDocument.position[0],
                                lng: this.props.onEditionDocument.position[1]
                            }}
                        />

                    </Map>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        firebase: state.firebase,
        stationsCollection: state.firebase.stationsCollection,
        onEditionDocument: state.stations.onEditionDocument,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ editDocument, getDocumentInfo }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(
    GoogleApiWrapper({
        apiKey: "AIzaSyBRt5tonSSUXJvKCIu4eZhDsjn8mEMOMl8"
    })(ViewStation)
)
